export interface Milestone {
  year: string;
  title: string;
  description: string;
}

export interface Testimonial {
  id: number;
  name: string;
  role: string;
  avatar: string;
  content: string;
  rating: number;
}

export const milestones: Milestone[] = [
  {
    year: '2018',
    title: '梦想起航',
    description: '国产视频大全正式成立，怀揣着打造国产视频精品平台的初心，以数十人小团队起步。',
  },
  {
    year: '2019',
    title: '内容突破',
    description: '平台视频内容突破10万部，与超过200家内容制作方建立合作关系，用户数突破百万。',
  },
  {
    year: '2020',
    title: '技术革新',
    description: '全面升级至4K超高清播放，引入AI智能推荐系统，个性化内容分发能力显著提升。',
  },
  {
    year: '2021',
    title: '生态构建',
    description: '推出创作者扶持计划，累计投入超5000万元支持原创内容生产，孵化优质创作者超千人。',
  },
  {
    year: '2022',
    title: '行业认可',
    description: '荣获年度最佳视频平台提名，被评为用户满意度最高的国产视频平台之一。',
  },
  {
    year: '2023',
    title: '国际化探索',
    description: '内容覆盖全球超过30个国家和地区，让世界看到更多优秀的中国视频内容。',
  },
  {
    year: '2024',
    title: '品质升级',
    description: '推出正版高清专区，与主流影视公司签订独家合作协议，内容品质全面升级。',
  },
  {
    year: '2025',
    title: '智能时代',
    description: 'AI驱动的智能内容平台全面上线，用户可通过语音、图像等多种方式发现喜爱内容。',
  },
  {
    year: '2026',
    title: '全新征程',
    description: '平台注册用户突破5000万，日活跃用户超千万，持续引领国产视频内容消费新风尚。',
  },
];

export const statistics = [
  { label: '视频总量', value: '50万+', icon: 'ri-video-line' },
  { label: '注册用户', value: '5000万+', icon: 'ri-user-line' },
  { label: '日活跃用户', value: '1000万+', icon: 'ri-fire-line' },
  { label: '内容合作方', value: '3000+', icon: 'ri-team-line' },
  { label: '原创创作者', value: '1万+', icon: 'ri-pencil-ruler-2-line' },
  { label: '覆盖国家', value: '30+', icon: 'ri-global-line' },
];

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: '张明',
    role: '资深影视爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20professional%20portrait%2C%20warm%20smile%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20business%20casual%20attire%2C%20friendly%20expression%2C%20high%20quality%20headshot&width=200&height=200&seq=avatar-01&orientation=squarish',
    content: '国产视频大全是我每天的必看平台！影视剧更新速度超快，画质清晰流畅，而且不用看广告，体验太好了。分类也很清晰，找片子特别方便。',
    rating: 5,
  },
  {
    id: 2,
    name: '李婷',
    role: '短视频创作者',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20professional%20portrait%2C%20confident%20smile%2C%20modern%20studio%20lighting%2C%20clean%20white%20background%2C%20creative%20professional%20look%2C%20warm%20natural%20makeup%2C%20high%20quality%20headshot&width=200&height=200&seq=avatar-02&orientation=squarish',
    content: '作为一个内容创作者，这个平台给了我很大的展示空间。创作者扶持计划真心给力，不仅有流量扶持还有创作基金，让原创作者能专心做内容。',
    rating: 5,
  },
  {
    id: 3,
    name: '王大伟',
    role: '纪录片爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20casual%20portrait%2C%20thoughtful%20expression%2C%20natural%20outdoor%20lighting%2C%20relaxed%20look%2C%20cultural%20enthusiast%20vibe%2C%20warm%20authentic%20headshot&width=200&height=200&seq=avatar-03&orientation=squarish',
    content: '纪录片频道的品质让我惊喜！国产纪录片的画面和叙事完全不输BBC，特别是美食和风光类的，每部都是精品。强烈推荐给所有纪录片爱好者。',
    rating: 5,
  },
  {
    id: 4,
    name: '陈小雅',
    role: '学生用户',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20bright%20smile%2C%20casual%20student%20look%2C%20natural%20lighting%2C%20warm%20and%20friendly%2C%20clean%20background%2C%20youthful%20energy&width=200&height=200&seq=avatar-04&orientation=squarish',
    content: '作为学生党，免费看高清视频简直太香了！而且教育频道有很多优质课程，帮我省了不少培训班的钱。推荐给所有想学习的同学。',
    rating: 4,
  },
];

export const contactInfo = {
  email: 'contact@guochanshipin.com',
  phone: '400-888-6666',
  address: '北京市朝阳区望京科技园A座18层',
  wechat: 'guochanshipin666',
  weibo: '@国产视频大全官方',
  workHours: '周一至周日 9:00 - 21:00',
};

export const faqData = [
  {
    question: '国产视频大全的视频资源是正版吗？',
    answer: '是的，我们平台所有视频内容均来自正版授权合作方，严格遵循知识产权保护法规。我们与超过3000家内容制作方、影视公司、独立创作者建立了正式合作关系，确保每一部视频都是合法授权的正版内容。',
  },
  {
    question: '需要付费才能观看吗？',
    answer: '国产视频大全提供大量免费高清内容供用户观看。同时我们也设有精品会员专区，提供更高画质、独家内容和去广告等增值服务，会员价格亲民。但我们始终坚持大部分优质内容免费向公众开放的核心理念。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '我们的平台全面支持多端播放，包括PC网页端、iOS和Android移动端、平板电脑以及智能电视。您可以通过浏览器直接访问，也可以下载我们的移动应用获得更好的观看体验，所有设备间观看历史和收藏无缝同步。',
  },
  {
    question: '如何成为平台的创作者？',
    answer: '您可以通过"创作者中心"提交入驻申请。我们欢迎所有热爱视频创作的伙伴加入。通过审核后，您将获得专属创作者后台、流量扶持、数据分析工具以及创作基金支持。我们特别鼓励优质原创内容的创作与分享。',
  },
  {
    question: '视频加载慢怎么办？',
    answer: '如果您遇到加载问题，建议：1）检查网络连接状态；2）尝试切换画质（从超清降至高清）；3）清除浏览器缓存；4）更换网络环境（如切换到WiFi）。我们的CDN节点已覆盖全国主要城市，通常播放体验流畅。如问题持续请通过客服渠道反馈。',
  },
  {
    question: '如何联系客服？',
    answer: '您可以通过以下方式联系我们：1）在线客服（网站右下角，7×24小时在线）；2）客服邮箱 contact@guochanshipin.com；3）客服电话 400-888-6666（每天9:00-21:00）；4）微信公众号搜索"国产视频大全"留言。我们承诺在工作时间内2小时内回复所有咨询。',
  },
];